import VistaAdmin from './VistaAdmin'

const AdminRoutes = [
    { path: '/admin', element: <VistaAdmin/>},
];

export default AdminRoutes;
